import { render, staticRenderFns } from "./ModalContactInfoSupplier.vue?vue&type=template&id=bdc044ba"
import script from "./ModalContactInfoSupplier.vue?vue&type=script&lang=js"
export * from "./ModalContactInfoSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports